export default "__VITE_ASSET__CUUZd7s2__"